import { getEnterprisesCredentials } from "utils/getEnterpriseCredentials";
import { reportGA4 } from "utils/pushDataLayer";
import { urlBase64ToUint8Array } from "utils/urlBase64ToUintArray";

const payload_headers = getEnterprisesCredentials();

export const gerarChavePublicaWebPush = async ({ isDev }) => {
  const path_url = isDev
    ? process.env.REACT_APP_WEBPUSH_PUBLICKEY_PME_URL_QA
    : process.env.REACT_APP_WEBPUSH_PUBLICKEY_PME_URL;

  if (isDev) {
    reportGA4({
      customCallback: "sucesso",
      customTitle: "gerar_chave_publica_web_push",
      event: "callback",
    });
    return Promise.resolve({ publicKey: "MOCK_DEV_PUBLIC_KEY" });
  }

  const response = await fetch(path_url, {
    headers: payload_headers,
    method: "GET",
    mode: "cors",
  });

  if (!response.ok) {
    reportGA4({
      customCallback: "erro",
      customTitle: "gerar_chave_publica_web_push",
      event: "callback",
    });
    throw new Error("Error when generating public Web Push key");
  }

  reportGA4({
    customCallback: "sucesso",
    customTitle: "gerar_chave_publica_web_push",
    event: "callback",
  });

  return response.json();
};

export const inscreverChavePublicaWebPush = async ({ body, isDev }) => {
  const path_url = isDev
    ? process.env.REACT_APP_WEBPUSH_SUBSCRIBE_PME_URL_QA
    : process.env.REACT_APP_WEBPUSH_SUBSCRIBE_PME_URL;

  const payload_body = body ? JSON.stringify(body.toJSON()) : null;

  if (isDev) {
    reportGA4({
      customCallback: "sucesso",
      customTitle: "inscrever_web_push",
      event: "callback",
    });
    return Promise.resolve({ message: "success" });
  }

  const response = await fetch(path_url, {
    method: "POST",
    headers: {
      ...payload_headers,
      accept: "application/json",
    },
    body: payload_body,
    mode: "cors",
  });

  if (!response.ok) {
    reportGA4({
      customCallback: "erro",
      customTitle: "inscrever_web_push",
      event: "callback",
    });
    throw new Error("Error when subscribing to Web Push");
  }

  reportGA4({
    customCallback: "sucesso",
    customTitle: "inscrever_web_push",
    event: "callback",
  });

  return response.json();
};

export const registrarWebPush = async ({ isDev }) => {
  if (!("serviceWorker" in navigator)) return;

  try {
    const serviceWorker = await navigator.serviceWorker.getRegistration();
    if (!serviceWorker) {
      console.warn("[WebPush] Nenhum service worker encontrado.");
      return;
    }

    const { pushManager } = serviceWorker;
    let subscription = await pushManager.getSubscription();

    if (subscription) {
      console.log("[WebPush] Subscription já existente:", subscription);
      return;
    }

    const { publicKey } = await gerarChavePublicaWebPush({ isDev });

    if (!publicKey) {
      console.warn("[WebPush] Nenhuma publicKey retornada do servidor.");
      return;
    }

    const applicationServerKey = isDev
      ? urlBase64ToUint8Array(
          process.env
            .REACT_APP_MOCK_DEV_PUBLIC_KEYBEl6wVZKr_QK6pXQZNRkFHUwKvMmg1b3JrwPiNcldSpmm7Ag6gzq4v
        )
      : publicKey;

    subscription = await pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey,
    });

    console.warn("[WebPush] Subscription criada com sucesso:", subscription);
    const subscriptionData = subscription.toJSON();
    console.log("[WebPush] Subscription gerada:", subscriptionData);
    console.warn("[WebPush] Enviando subscription para backend:", {
      endpoint: subscription.endpoint,
      keys: subscription.toJSON().keys,
    });

    const subscribeResponse = await inscreverChavePublicaWebPush({
      body: subscription,
      isDev,
    });

    if (isDev) {
      console.log("[WebPush] Registro em modo DEV completo.");
      return Promise.resolve({ message: "success" });
    }

    if (!subscribeResponse.message) {
      throw new Error("registration failed webpush error: without message");
    }

    console.warn("[WebPush] Registro finalizado com sucesso!");
  } catch (err) {
    console.error("[WebPush] Erro ao registrar:", err);
    throw new Error("registration failed webpush error: response error");
  }
};
